import React from 'react';

export default ({theme = 'default', value, label, ...rest}) => (
	<label className={`Checkbox Checkbox--${theme}`+(rest.disabled ? ' Checkbox--disabled' : '')}>
		<input type='checkbox' checked={value === 'y'} value='y' {...rest}/> <h6>{label}</h6>
	</label>
);